module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABZUlEQVRoQ93a7VECMRCA4ZcKsAMtgQ7UTqQD6QArUDrQCrQD6UTphNmZY4ZhuINssh/hft7kJvtkkx+7uRk38sxuxEEmyCOwA/41i5sBsgC+gYcB8AGsSjHREEH8AncngT8D2xJMJGQMIfG/AeseIFMIib+LjFxCfAEvJdmQsd5bywThDTFDeEJMEV4Qc4QHxAVhDXFDWEJcEVYQd4QFJATRGhKGaAkJRbSChCNaQFIgaiFpEDWQVAgtRMrSvzPl6aGEUNUTpfXH6XhNPfIKvI9MHILQZmQK8gksa1dX870mI7K1pPc0H5kwBKOBSPxy2KVdkwajhaTD1EBSYWohaTAtICkwrSDhmJaQUExrSBjGAhKCsYK4YywhrhhriBvGA+KC8YKYYzwhphhviBkmAnINpovL0ENhOVWcdXM9fQnTVUaOMT/A/fBiA0iDo+iJOiPngnwamhrd/lRTtPJjgzNlpAq0BwgqXDPAcwJuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leftArrow-black.png
// module id = 5A6F
// module chunks = 8